<template lang="pug">
.wrapper
  EcreativArchetypesInteractiveArchetype.back-to-top.bg-dark(
    v-show="visible"
    componentType="Interactive"
    text=""
    context="primary"
    linkColor="white"
    link="javascript:void(0)"
    @click="scrollTop"
  )
    template(#icon)
      EcreativAtomsSvgIcon(iconName='chevronUp' :isCustom='true', iconSize="sm")
</template>

<script setup>
/* eslint-disable */
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useNuxtApp } from '#imports';

const { $scrollTo } = useNuxtApp();

const visible = ref(false);

const scrollListener = () => {
  visible.value = window.scrollY > 150;
};

const scrollTop = () => {
  const body = document.querySelector('body');
  $scrollTo(body, 500, { offset: -60, easing: 'smooth' });
};

const throttle = (fn, wait) => {
  let time = Date.now();
  return function () {
    if (time + wait - Date.now() < 0) {
      fn();
      time = Date.now();
    }
  };
};

onBeforeUnmount(() => {
  window.removeEventListener('scroll', scrollListener);
});

onMounted(() => {
  window.addEventListener('scroll', throttle(scrollListener, 200));
});
</script>
<style lang="scss" scoped>
.wrapper {
  position: fixed;
  right: 8px;
  bottom: 90px;
  z-index: 9999;
  mix-blend-mode: difference;

  @include media-breakpoint-up(sm) {
    right: 24px;
    filter: invert(1);
  }
}

.back-to-top {
  display: flex;
  justify-content: center;
  width: 40px !important;
  height: 40px !important;
  color: $white;
  border-radius: 3px;
}
</style>
